(function($)
{
    $.extend(true, orion, {
        api: {
            cart: {
                orderitems: {}
            }
        }
    });

    var
        api = orion.api.cart.orderitems,
        uri = '/api-cart-orderitems';

    function create(data)
    {
        var
            promise = $.ajax(uri, {
                'cache': false,
                headers: {
                    'Accept': 'application/json',
                },
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                'method': 'PUT'
            });

        return promise;
    }

    function add(data)
    {
        var
            promise = $.ajax(uri + '/add-to-cart', {
                'cache': false,
                headers: {
                    'Accept': 'application/json',
                },
                dataType: 'json',
                contentType: 'application/json',
                data: JSON.stringify(data),
                'method': 'PUT'
            });

        return promise;
    }

    function read(data)
    {
        var
            promise = $.ajax(uri + '/' + data.productNumber, {
                'cache': false,
                'method': 'GET'
            });

        return promise;
    }

    function update(data)
    {
        var
            promise = $.ajax(uri + '/' + data.productNumber, {
                'cache': false,
                'data': $.extend({}, data, {
                    '_method': 'PUT'
                }),
                'method': 'POST'
            });

        return promise;
    }

    function del(data)
    {
        var
            promise = $.ajax(uri + '/' + data.productNumber, {
                'cache': false,
                'data': $.extend({}, data, {
                    '_method': 'DELETE'
                }),
                'method': 'POST'
            });

        return promise;
    }

    api.create = create;
    api.add = add;
    api.read = read;
    api.update = update;
    api.del = del;
})(jQuery);
